if (!customElements.get("scroll-to")) {
  class ScrollTo extends HTMLElement {
    constructor() {
      super();

      this.scrollTrigger = this.querySelector("a.scrollTo");
    }

    scrollTo = (e) => {
      e.preventDefault();

      document.querySelector(e.target.getAttribute("href")).scrollIntoView({
        behavior: "smooth",
      });
    };

    connectedCallback() {
      this.scrollTrigger.addEventListener("click", this.scrollTo.bind(this));
    }
    disconnectedCallback() {}
  }

  customElements.define("scroll-to", ScrollTo);
}
